export const MASTER_DATA_EXCHANGES = ['IEX', 'PXIL', 'HPX'] as const;
export const MASTER_DATA_PRODUCTS = ['DAM', 'RTM', 'GDAM', 'HPDAM'] as const;
export const MASTER_DATA_FREQUENCIES = [
  { value: '15_MIN', label: '15 Min' },
  { value: 'DAILY', label: 'Daily' },
  { value: 'MONTHLY', label: 'Monthly' },
] as const;

export function getCurrentMonthValue(): string {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, '0');
  return `${year}-${month}`;
}

export function getTodayDateValue(): string {
  return formatDateControlValue(new Date());
}

export function getDefaultDailyFromDateValue(): string {
  const today = new Date();
  today.setDate(today.getDate() - 6);
  return formatDateControlValue(today);
}

function formatDateControlValue(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function formatMasterDataDateLabel(dateValue: string): string {
  const parsedDate = new Date(`${dateValue}T00:00:00`);
  if (Number.isNaN(parsedDate.getTime())) {
    return '-';
  }

  const day = String(parsedDate.getDate()).padStart(2, '0');
  const month = String(parsedDate.getMonth() + 1).padStart(2, '0');
  const year = String(parsedDate.getFullYear());
  return `${day}-${month}-${year}`;
}

export function formatMasterDataMonthLabel(monthValue: string): string {
  const parsedDate = new Date(`${monthValue}-01T00:00:00`);
  if (Number.isNaN(parsedDate.getTime())) {
    return '-';
  }

  return parsedDate.toLocaleString(undefined, { month: 'short', year: 'numeric' });
}

export function getMonthStartDateValue(monthValue: string): string {
  return `${monthValue}-01`;
}

export function getMonthEndDateValue(monthValue: string): string {
  const parsedDate = new Date(`${monthValue}-01T00:00:00`);
  if (Number.isNaN(parsedDate.getTime())) {
    return `${monthValue}-01`;
  }

  const year = parsedDate.getFullYear();
  const month = parsedDate.getMonth();
  const lastDay = new Date(year, month + 1, 0).getDate();
  const monthNumber = String(month + 1).padStart(2, '0');
  const day = String(lastDay).padStart(2, '0');
  return `${year}-${monthNumber}-${day}`;
}
